import { z } from 'zod';
import { IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
export const WebhookSourceSchema = z.enum([
    'public_lead_form',
    'docusign_connect',
    'quickbooks_webhook',
]);
export const WebhookSecretSchema = z.object({
    id: z.string(),
    type: z.literal('webhook_secret'),
    schemaVersion: SchemaVersionSchema,
    source: WebhookSourceSchema,
    secretHash: z.string(),
    enabled: z.boolean().default(true),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    rotatedAt: IsoTimestampSchema.optional(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=webhook-secret.js.map